import React from "react";
import { cn } from "@/lib/utils";
import { formatTimeLabel } from "@/lib/availability";
import { Star } from "lucide-react";

/**
 * A single toggleable time slot button.
 * Props:
 *  - time: "09:30"
 *  - selected: boolean
 *  - preferred?: boolean (shows a star badge when true)
 *  - onClick
 *  - mode: "pick" | "prefer" - just drives color accent
 */
export const SlotButton = ({
  time,
  selected,
  preferred,
  onClick,
  mode = "pick",
  disabled,
  testId,
}) => {
  const accent =
    mode === "prefer"
      ? "bg-[#ffd60a] hover:bg-[#ffea5c]"
      : "bg-[#c4f04a] hover:bg-[#d8ff78]";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={cn(
        "relative w-full min-h-11 rounded-lg border-[2px] px-2 sm:px-3 py-2 text-[12px] sm:text-[13px] font-bold font-mono transition-all",
        "hover:-translate-y-[2px] hover:shadow-[4px_4px_0_0_#000]",
        "active:translate-y-[1px] active:shadow-[1px_1px_0_0_#000]",
        "disabled:opacity-40 disabled:cursor-not-allowed",
        preferred ? "border-[#ff5e78]" : "border-black",
        selected
          ? `${accent} shadow-[3px_3px_0_0_#000]`
          : "bg-white shadow-[2px_2px_0_0_#000]"
      )}
    >
      <span>{formatTimeLabel(time)}</span>
      {preferred && (
        <Star
          className="absolute -top-2 -right-2 w-4 h-4 fill-[#ff5e78] text-black stroke-[2.5]"
          aria-label="preferred"
        />
      )}
    </button>
  );
};
